import { HOME_URL, DIRECTORIES_URL, SOURCE_CREATE_URL, SOURCE_URL } from 'components/Router/consts';

export default function makeSourceCreateBaseUrl(directoryId?: string, sourceId?: string) {
  const directoryIdPath = directoryId ? `/${directoryId}` : '';
  const sourcePath = sourceId ? `${SOURCE_URL}/${sourceId}` : '';

  return `${HOME_URL}${DIRECTORIES_URL}${directoryIdPath}${sourcePath}${SOURCE_CREATE_URL}`;
}
